module.exports = __webpack_public_path__ + "img/fondo1.7c56a949.jpg";